const Backbone = require('backbone');
const dustjs = require('dustjs');
const _rebatesDust = require('store/global/pages/products/_rebates.dust');
const RebatesModel = require('models/store/client/common/rebates');
const AccordionView = require('views/store/common/components/accordion/accordion');
require('common/_modal.dust');
require('store/global/pages/products/rebate_details.dust');
require('store/global/pages/products/rebate_modal.dust');
require('store/global/components/accordion/_accordion.dust');

module.exports = Backbone.View.extend({
	el: '#ecoRebates',

	events: {
		'click .js-rebate-details': '_openDetailModal'
	},

	initialize: function() {
		this.listenTo(Backbone, 'zipCode:changed', this._fetchRebates);
		const currentZipCode = window.dataLayer.customerLocation && window.dataLayer.customerLocation.zipCode;
		this._fetchRebates(currentZipCode);
	},

	_openDetailModal: function() {
		this.$detailModal = this.$el.find('.js-modal-ecorebates-details');
		this.$detailModal.modal('show');
	},

	_fetchRebates: function(zipCode) {
		const isUnitedStatesCustomer = !window.BCOM.util.validator.isCanadaZip(zipCode),
			uniqueId = window.dataLayer.selectedFinish && window.dataLayer.selectedFinish.uniqueId;
		if (!uniqueId || !isUnitedStatesCustomer) {
			this._renderRebates({});
			return;
		}
		this.rebatesModel = new RebatesModel({
			uniqueId,
			zipCode
		});
		if (this.rebatesModel.isValid()) {
			this.rebatesModel.fetch({
				success: (model, response) => {
					this._renderRebates(response);
				}
			});
		}
	},

	_renderRebates(response) {
		dustjs.render(_rebatesDust, response, (err, out) => {
			if (!err) {
				this.$el.html(out);
				const $accordion = this.$el.find('.js-accordion-component');
				$accordion.data(
					'componentView',
					new AccordionView({
						el: $accordion
					})
				);
			} else {
				window.clientErrorHandler(err);
			}
		});
	}
});
